// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2Sg8B","left":"InfoRow_left__1p9VE"};